<template>
  <div class="button-content" @click="handelToPersonalizedPage">
    {{ $t('admin.hrDashboard.btn.personalize') }}
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
  },
  created () {

  },
  mounted () {
  },
  methods: {
    handelToPersonalizedPage () {
      this.$router.push({ name: 'hrDashboardPersonalized' })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-content {
  height: 38px;
  background: #FFFFFF;
  border-radius: 23px;
  border: 1px solid #0096CC;
  font-size: 14px;
  text-align: center;
  font-weight: 400;
  color: #0096CC;
  line-height: 36px;
  cursor: pointer;
}
</style>
